export const PROJECT_STATS = {
  appDownloads: { value: 100, suffix: "+" },
  citiesAvailable: { value: 12, suffix: "+" },
  userRatings: { value: 4.9, suffix: "/5", decimal: true },
};